<main>
    <div class="content">
        <div class="paragraph">
            <div class="title">
                <div *ngIf="currentLanguage === 'en'">
                    <h4>{{ galleryDetail.title }}</h4>
                </div>
                <div *ngIf="currentLanguage === 'kh'">
                    <h4>{{ galleryDetail.title_kh }}</h4>
                </div>
            </div>
        </div>
        <div class="images" *ngIf="galleryDetail.files && galleryDetail.files.length > 0">
            <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-3 col-12 mb-3" *ngFor="let gallery of galleryDetail.files" (click)="openImage(gallery.file_url)">
                    <img [src]="baseApiUrl + '/' + gallery.file_url">
                </div>
            </div>
        </div>
    </div>

    <!-- Popup Modal -->
    <div class="popup" *ngIf="selectedImage" (click)="closeImage()">
        <div class="popup-content" (click)="$event.stopPropagation()">
          <span class="close" (click)="closeImage()">×</span>
          <img [src]="selectedImage" alt="Large Image">
        </div>
    </div>

</main>